/* import __COLOCATED_TEMPLATE__ from './procedure-static-chart.hbs'; */
/* RESPONSIBLE TEAM: team-actions */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import Range from 'embercom/models/reporting/range';
import moment from 'moment-timezone';
import type AppService from 'embercom/services/app-service';

interface ProcedureStaticChartSignature {
  Args: {
    statType: string;
    label: string;
    procedureId: string;
    chartDefinition: any;
    selectedProcedureId?: string;
    selectedStat?: string;
    drillInColumns: string[];
    onOpenSideDrawer: (procedureId: string, stat: string, event: Event) => void;
    onCloseSideDrawer: () => void;
    tooltip: string;
  };
  Element: HTMLDivElement;
}

export default class ProcedureStaticChart extends Component<ProcedureStaticChartSignature> {
  @service declare appService: AppService;

  get isSideDrawerOpen(): boolean {
    return !!(
      this.args.selectedProcedureId &&
      this.args.selectedProcedureId === this.args.procedureId &&
      this.args.selectedStat === this.args.statType
    );
  }

  get dateRange(): Range {
    let timezone = this.appService.app.timezone;
    let to = moment.tz(timezone).endOf('day');
    let from = moment.tz(timezone).subtract(1, 'year').startOf('day');

    return Range.createFromParams(from.format(), to.format(), timezone);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Tasks::ProcedureStaticChart': typeof ProcedureStaticChart;
    'standalone/tasks/procedure-static-chart': typeof ProcedureStaticChart;
  }
}
